<template>
  <v-container>
    <div>
      <h1>Datensatz Zonenplan</h1>
      <p>Dieser Datensatz beinhaltet die Flächen der Grundnutzungszonen mit den Zonenbezeichnungen. Für die Berechnung sind nur die Bauzonen erforderlich. Die einzelnen Parameter für die Zonendefinition (wie ÜZ, BMZ usw.) sind nicht erforderlich und können direkt online editiert werden. Falls die Parameter bereits im Datensatz vorhanden sind, können diese auch mitgeliefert werden.</p>
      <p><b>Datenquelle</b><br />GIS-Dienstleister / Raumplaner</p>
      <p><b>Format</b><br />Shape-File (.shp) mit allen dazugehörigen formatspezifischen Dateien (.prj, .dbf, .shx, optional .cpg). Alle Dateien müssen in einem ZIP-File komprimiert und hochgeladen werden.<br />Koordinatensystem: Swiss CH1903+ / LV95; EPSG: 2056</p>
          <p>
            <v-simple-table>
            <template v-slot:default>
            <thead>
                <tr>
                <th class="text-left">
                    Name
                </th>
                <th class="text-left">
                    Beschreibung
                </th>
                <th class="text-left">
                    Einheit
                </th>
                </tr>
            </thead>
            <tbody>
                <tr
                v-for="item in attributes"
                :key="item.name"
                >
                <td>{{ item.name }}</td>
                <td>{{ item.desc }}</td>
                <td>{{ item.unit }}</td>
                </tr>
            </tbody>
            </template>
                  </v-simple-table>
          </p>
      <!-- <p>TODO Download Beispieldatensatz</p> -->
    </div>
  </v-container>

</template>

<script>
export default {
  name: 'DocStr',
  data () {
    return {
      attributes: [
        {
          name: 'geom',
          desc: 'Die Bauzonenfläche als korrekte Geometrie ohne Überlappungen.',
          unit: 'Polygon/Multipolygon'
        },
        {
          name: 'bezeichn',
          desc: 'Bezeichnung der Zone in voller Länge.\nZ.B. \'Wohn- und Arbeitszone A\'',
          unit: 'Text (max. 100 Zeichen)'
        },
        {
          name: 'kurzbez',
          desc: 'Kurzbezeichnung der Zone. Z.B. \'WA-A\'',
          unit: 'Text (max. 7 Zeichen)'
        },
        {
          name: 'istbz',
          desc: 'Ist die Zone eine Bauzone - true/false. (Nur Bauzonen werden in der Berechnung berücksichtigt.). Standard: false',
          unit: 'Boolean'
        }
        // {
        //   name: 'uez_max (optional/editierbar)',
        //   desc: 'Maximal mögliche Überbauungsziffer.',
        //   unit: 'zahl (0.0 - 1.0)'
        // },
        // {
        //   name: 'uez_min (optional/editierbar)',
        //   desc: 'Minimale überbauungszimmer. (Einschränkungs indikator für Bebaubarkeit)',
        //   unit: 'zahl (0.0 - 1.0)'
        // },
        // {
        //   name: 'bm_max (optional/editierbar)',
        //   desc: 'Maximal mögliche Baumassenziffer.',
        //   unit: 'zahl (>= 0.0)'
        // },
        // {
        //   name: 'bm_min (optional/editierbar)',
        //   desc: 'Baumassenziffer min. (Einschränkungs indikator für Bebaubarkeit)',
        //   unit: 'zahl (>= 0.0)'
        // },
        // {
        //   name: 'az_max (optional/editierbar)',
        //   desc: 'Ausnützungsziffer max.',
        //   unit: 'zahl (>= 0.0)'
        // },
        // {
        //   name: 'az_min (optional/editierbar)',
        //   desc: 'Ausnützungsziffer min. (Einschränkungs indikator für Bebaubarkeit)',
        //   unit: 'zahl (>= 0.0)'
        // }

      ]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/docs/DocZp.vue